import {z} from "zod"
import {JobNodes, makeJobTaskDescriptor} from "#job-nodes/job-nodes"
import {MediaType} from "@cm/utils"

export enum FabricOverviewGenerateTemplateType {
    FullWidthWide = "FullWidthWide",
    FullWidthSlim = "FullWidthSlim",
    FullWidthSlimWithRepeat = "FullWidthSlimWithRepeat",
}

export const FabricOverviewGenerateInputSchema = z.object({
    templateType: z.nativeEnum(FabricOverviewGenerateTemplateType),
    tileableImage: JobNodes.DataObjectReferenceSchema,
    mediaType: z.nativeEnum(MediaType),
    fullWidthCm: z.number(),
    repeatWidthCm: z.number().optional(),
    repeatHeightCm: z.number().optional(),
    railroaded: z.boolean().optional(),
})

export type FabricOverviewGenerateInput = z.infer<typeof FabricOverviewGenerateInputSchema>

export const FabricOverviewGenerateOutputSchema = z.object({
    dataObject: JobNodes.DataObjectReferenceSchema,
})

export type FabricOverviewGenerateOutput = z.infer<typeof FabricOverviewGenerateOutputSchema>

export const fabricOverviewGenerateTask = makeJobTaskDescriptor<FabricOverviewGenerateInput, FabricOverviewGenerateOutput>("FabricOverview.generate", 1)
